import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { fetchPosts } from '../../services/api'; // Assuming you have this function to fetch posts
import { fetchLatestPosts } from '../../services/api'; // Use the new function to fetch limited posts
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap CSS import
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import BreakingNewsBanner from '../widgets/BreakingNewsBanner';
import CategoriesBanner from '../widgets/CategoriesBanner';
import CategoryArticles from '../English/CategoryArticles';
import Videos from '../English/Videos';
import MostViewed from './MostViewed';
import MostLiked from './MostLiked';
import MostComment from './MostComment';
import ReverseVideos from '../English/ReverseVideos';
import RandomVideos from '../English/RandomVideos';
import SubscribeSection from './subscribe';
import LatestImages from './LatestImages';
import AudioList from './AudioList';
import UserPosts from '../SaaS/UserPosts';

import ExploreFeatures from '../English/ExploreFeatures';
import JoinCommunity from '../English/JoinCommunity';

const HomeEnglish = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [selectedCategory, setSelectedCategory] = useState(null);

    const navigate = useNavigate(); // Initialize navigate function

    const getPosts = async (categoryId = null) => {
        setLoading(true);
        try {
            const fetchedPosts = await fetchLatestPosts('en'); // Fetch only English posts (latest 13)
            const englishPosts = fetchedPosts.filter(
                (post) => post.language === 'en' && (!categoryId || post.category === categoryId)
            );
            setPosts(englishPosts); // Set the posts after filtering
        } catch (err) {
            setError('Failed to fetch posts');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getPosts(); // Fetch the posts when the component mounts
    }, []);

    const handleCategorySelect = (categoryId, categoryName) => {
        setSelectedCategory(categoryId);
        getPosts(categoryId);
        navigate(`/category/${categoryId}`); // Navigate to the selected category's URL
    };

    if (loading) {
        return <div className="text-center mt-5 fw-bold">Loading...</div>;
    }

    if (error) {
        return <div className="text-center mt-5 text-danger">{error}</div>;
    }

    if (posts.length === 0) {
        return <div className="text-center mt-5">No English posts available</div>;
    }

    return (
        <div
            className="container-fluid mt-1"
            style={{
                maxWidth: '1500px',
                margin: '0 auto',
                paddingLeft: '75px',
                paddingRight: '75px',
            }}
        >
            <BreakingNewsBanner /> {/* Add Breaking News Banner below Navbar */}
            {/*<h1 className="mb-4">Blog Posts (English)</h1>*/}
            <div className="row d-flex" style={{ minHeight: '100vh' }}>
                {/* Left Column */}
                <div className="col-md-6 d-flex flex-column">
                    {posts.slice(0, 5).map((post, index) => (
                        <a
                            key={post.id}
                            href={`/posts/${post.slug}`}
                            className="text-decoration-none text-dark mb-4"
                        >
                            <div
                                className={`d-flex align-items-center shadow-sm p-3 post-card ${index === 0 ? 'large-post' : 'small-post'
                                    }`}
                                style={{
                                    height: index === 0 ? '220px' : '100px', // keep different heights
                                }}
                            >
                                <div
                                    style={{
                                        width: index === 0 ? '40%' : '20%',
                                        height: '100%',
                                        overflow: 'hidden',
                                        flexShrink: 0,
                                        borderRadius: '5px',
                                    }}
                                >
                                    <img
                                        src={`https://res.cloudinary.com/dbm8xbouw/${post.featured_image}`}
                                        alt={post.title}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </div>
                                <div className="ms-3" style={{ flex: 1 }}>
                                    <h5
                                        className="mb-0"
                                        style={{
                                            whiteSpace: 'normal', // Allow wrapping
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: '-webkit-box',
                                            WebkitLineClamp: index === 0 ? 3 : 2, // Control lines for large vs. small posts
                                            WebkitBoxOrient: 'vertical',
                                            maxHeight: index === 0 ? '4.5em' : '3em', // Constrain height
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {post.title}
                                    </h5>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>

                {/* Right Column */}
                <div className="col-md-6 d-flex flex-column">
                    {posts.slice(5, 11).map((post) => (
                        <a
                            key={post.id}
                            href={`/posts/${post.slug}`}
                            className="text-decoration-none text-dark mb-4"
                        >
                            <div
                                className="d-flex align-items-center shadow-sm p-3 small-post post-card"
                                style={{
                                    height: '100px', // keep size inline or use CSS
                                }}
                            >

                                <div
                                    style={{
                                        width: '20%',
                                        height: '100%',
                                        overflow: 'hidden',
                                        flexShrink: 0,
                                        borderRadius: '5px',
                                    }}
                                >
                                    <img
                                        src={`https://res.cloudinary.com/dbm8xbouw/${post.featured_image}`}
                                        alt={post.title}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </div>
                                <div className="ms-3" style={{ flex: 1 }}>
                                    <h5
                                        className="mb-0"
                                        style={{
                                            whiteSpace: 'normal', // Allow wrapping
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2, // Limit to 2 lines
                                            WebkitBoxOrient: 'vertical',
                                            maxHeight: '3em', // Constrain height
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {post.title}
                                    </h5>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>

            {/* View More Button */}
            <div className="text-center mt-4">
                <a href="/en/articles" className="btn btn-outline-dark fw-bold btn-lg">
                    View More Articles
                </a>
            </div>

            {/* Videos Section */}
            <h2 className="fw-bold mt-5">| Watch Latest Videos</h2>
            <div className="videos-section mt-3"
            style={{
                border: '4px solid #F9FAFC', // Adds a 2px solid border with a light gray color
                padding: '20px', // Adds padding inside the border
                borderRadius: '8px', // Optional: Adds rounded corners
            }}
            >
              {/*  <h2 className="text-center">Latest Videos</h2>*/}
                <Videos />  {/* Include the Videos component here */}
            </div>

            <ExploreFeatures />

            {/* Most Viewed Posts Section */}
            <MostViewed /> {/* Include MostViewed component */}

            {/* View More Button */}
            <div className="text-center mt-4 mb-5">
                <a href="/en/articles" className="btn btn-outline-dark fw-bold btn-lg">
                    View More Articles
                </a>
            </div>

            

            {/* Images and Audio columns */}
            <div
                className="media-section mt-3"
                style={{
                    display: 'flex',
                    gap: '2rem',
                    alignItems: 'flex-start',
                }}
            >
                {/* Left: Latest Images */}
                <div style={{
                    flex: 2
                }}>
                    <LatestImages /> {/* Remove internal title */}
                </div>

                {/* Right: Audio List */}
                <div style={{ flex: 1 }}>
                    <AudioList /> {/* Remove internal title */}
                </div>
            </div>



            {/* User Posts Section */}
            <UserPosts /> {/* Include User posts component */}
            {/* View All User Articles Button */}
            <div className="text-center mt-4 mb-5">
                <a
                    href="/user-articles"
                    className="btn btn-outline-dark fw-bold btn-lg"
                >
                    View Community Articles
                </a>
            </div>

            {/* Join the Community */}
            <JoinCommunity />

            <div className="mt-4 mb-5">
            <SubscribeSection /> {/* Include subscribe component */}
            </div>

        </div>
    );
};

export default HomeEnglish;